export default __webpack_public_path__ + "static/media/regulatory--stop-here-on-red-or-flashing-light--g2.1407c908.png";